core.constant('invoiceMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "APPLICATION" : {
          "INVOICES" : "Faktury/Zlecenia"
        },
        "TABBAR": {
        },
        "BREADCRUMB": {
        }
      },
      "ENUM": {
        "INVOICE_STATUS" : {
          "SEND_TO_INSURER" : "Wystawiona",
          "WAITING_FOR_ACCEPTATION" : "Czekająca na akceptacje"
        }
      },
      "MODULE": {
        "TITLE": {
          "MODULE_LOGIN": "Moduł logowania"
        },
        "INVOICE": {
          "SEARCH_PHRASE" : "Wpisz numer dokumentu lub/i odbiorcy",
          "DATE_FROM" : "Data od",
          "DATE_TO" : "Data do",
          "INVOICE" : "Faktura",
          "INVOICES" : "Faktury/Zlecenia",
          "INVOICE_DATE" : "Data wystawienia",
          "NUMBER" : "Nr dokumentu",
          "BUYER_NAME" : "Odbiorca",
          "NET_VALUE" : "Wartość netto",
          "TAX_RATE" : "VAT",
          "GROSS_VALUE" : "Wartość brutto",
          "ACTION" : "Pliki do pobrania",
          "PDF" : ".PDF",
          "XLS" : ".XLS",
          "ISSUE" : "Wystaw",
          "BASE_DATA" : "Dane podstawowe",
          "EDIT_INVOICE" : "Edycja faktury"
        }
      }
    }
  }
});
